import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import { clone } from '../../../core/utils';
import { formatDate } from '../../../components/renderers';
import { create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';

const s:any = {
  reqform: {
    //
  },
};

class TeammemberPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: false,
      count: 0,
    };
  }

  componentDidMount() {
    this.props.setValid(this.state.valid);
  }

  formconfig = () => {
    //combo.inputLabelProps => cilp
    //const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service: {
      name: 'teammember',
      title: 'Team Member',
      key: 'rid',
      num: true,
      fields: ['rid','dvn','dvk','dvc','dvm','dsc','dti','dtn','dtc','eni','enm','enc','lci','lcn','lcc','geo','dcd','exi','sts','ast','stp'],
      params: {tsc:'Team',mnm:'Member',rsc:'Team Role',dsc:'Description',exi:'Extrainfo',sts:'Status'},
      grid: [['tsc','Team'],['mnm','Member'],['rsc','Team Member Role'],['dsc','Description'],['stp','Created']],
		  bar: {pag:true,btn:['add','edit','del','view']},
      menu: {mnu:[{t:'Name',v:'dvn'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        //{id:'tid',label:'Team',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'team'}},
            {id:'iid',label:'Member',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitor'}},
            {id:'iri',label:'Team Member Role',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'teamrole'}},
            {id:'ids',label:'Description',type:'ta',req:0,ops:{},},
            {id:'ixi',label:'Extra Info',type:'jf',req:0,ops:{}},
            {id:'xms',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {add:'Add'},
    panels: {add:'simple'},
    };
    return config;
  };

  setValid = (data: any) => {
    const sconfig = this.formconfig();
    const { mode } = this.props;
    const valid = ['del', 'delete'].includes(mode)
      ? true
      : isValid(sconfig, data, mode);
    //console.log('valid:',valid);

    //const valid = (!!newdata.nam && !!newdata.agc && !!newdata.mbn && !!newdata.lci);
    //const valid = (!!data.wsu && !!data.cbu && !!data.cbc && !!data.cba);
    //console.log('valid:',valid);
    this.props.setValid(valid);
  };

  onChange = (name: any) => (value: any, selected: any) => {
    const { data } = this.props;
    const newdata = { ...data.data, [name]: value };
    const displayValues = { ...(data.displayValues || {}) };
    if (selected && typeof selected === 'object' && selected.nam) {
      displayValues[name] = selected.nam;
    } else {
      delete displayValues[name];
    }
    this.setValid(newdata);
    this.props.setItem('data', 'data', newdata);
    this.props.setItem('data', 'displayValues', displayValues);
  };

  makeform = () => {
    const config = this.formconfig();

    const { record, extras, classes } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(
      mode,
      sdata,
      record,
      formatters,
      onChange,
      classes,
      extras
    );
    return form;
  };

  render() {
    //const {data,classes} = this.props;
    const form = this.makeform();
    return form;
  }
}

TeammemberPanel.propTypes = {
  classes: PropTypes.object,
};

export default TeammemberPanel;
